import { useState } from 'react';
import HeartbeatIcon from './HeartbeatIcon';
import type { Message } from '../types';

interface Props {
  count: number;
  messages: Message[];
}

export default function HeartbeatCollapsed({ count, messages }: Props) {
  const [expanded, setExpanded] = useState(false);

  const first = messages[0];
  const last = messages[messages.length - 1];
  const firstTime = new Date(first.created_at);
  const lastTime = new Date(last.created_at);
  const fmt = (d: Date) => d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  if (expanded) {
    return (
      <div className="heartbeat-collapsed-group">
        <div className="heartbeat-collapsed-header" role="button" tabIndex={0} onClick={() => setExpanded(false)} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setExpanded(false); } }}>
          <HeartbeatIcon size={14} active={false} />
          <span>Heartbeat × {count}</span>
          <span className="message-heartbeat-time">{fmt(firstTime)} – {fmt(lastTime)}</span>
        </div>
        {messages.map(msg => {
          const t = new Date(msg.created_at);
          return (
            <div key={msg.id} className="message-heartbeat">
              <HeartbeatIcon size={14} active={false} />
              <span>Heartbeat: status update requested</span>
              <span className="message-heartbeat-time">{fmt(t)}</span>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="heartbeat-collapsed" role="button" tabIndex={0} onClick={() => setExpanded(true)} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setExpanded(true); } }}>
      <HeartbeatIcon size={14} active={false} />
      <span>Heartbeat × {count}</span>
      <span className="message-heartbeat-time">{fmt(firstTime)} – {fmt(lastTime)}</span>
    </div>
  );
}
